export const PIXELS_PER_METER = 50;

// Approximate width/depth of a restaurant chair in meters
export const CHAIR_SIZE_M = 0.45;
export const CHAIR_SIZE_PX = CHAIR_SIZE_M * PIXELS_PER_METER;

const SEAT_SPACE_M = 0.5; // approximate meters occupied per seat along table sides

export function calculateTableDimensions(
  shape: 'square' | 'rectangle' | 'circle',
  seats: number
) {
  if (shape === 'square') {
    const sideSeats = Math.ceil(Math.sqrt(seats));
    const sideMeters = sideSeats * SEAT_SPACE_M;
    const size = sideMeters * PIXELS_PER_METER;
    return { width: size, height: size };
  }

  if (shape === 'rectangle') {
    const longSideSeats = Math.ceil(seats / 2);
    const longSideMeters = longSideSeats * SEAT_SPACE_M;
    const shortSideMeters = SEAT_SPACE_M * 2; // around 1m for two seats
    return {
      width: longSideMeters * PIXELS_PER_METER,
      height: shortSideMeters * PIXELS_PER_METER
    };
  }

  // circle
  const diameterMeters = Math.max(1, (seats * SEAT_SPACE_M) / Math.PI);
  const size = diameterMeters * PIXELS_PER_METER;
  return { width: size, height: size };
}

